var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipsBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 95,
    viewBox: "0 0 66 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M32.8789 56.832L0 75.8161L32.8789 94.8002L65.8173 75.8091L32.8789 56.832Z",
    fill: "url(#paint0_linear_438_1236)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93457 58.4354L24.1761 70.1227V23.3736L3.93457 11.6863V58.4354Z",
    fill: "url(#paint1_linear_438_1236)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.918 46.7491L44.1595 58.4364V11.6873L23.918 0V46.7491Z",
    fill: "url(#paint2_linear_438_1236)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4173 81.8099V58.4353L24.1758 46.748V70.1226L44.4173 81.8099Z",
    fill: "url(#paint3_linear_438_1236)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6341 70.1239V46.7493L44.3926 35.062V58.4366L64.6341 70.1239Z",
    fill: "#41DCEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93457 11.6861L24.1761 23.3734L44.1593 11.6873L23.9178 0L3.93457 11.6861Z",
    fill: "#41DCEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4171 81.8097L64.6341 70.1236V46.749L44.3926 58.4363L44.4171 81.8097Z",
    fill: "url(#paint4_linear_438_1236)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3928 35.062L64.6343 46.7493L44.3928 58.4366L24.1758 46.7481L44.3928 35.062Z",
    fill: "url(#paint5_linear_438_1236)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3928 58.4364L54.7361 40.7775L34.2995 29.2188L24.1758 46.7479L44.3928 58.4364Z",
    fill: "#09D5E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1423 31.4193L27.4683 48.8269C26.9061 49.7407 25.7165 50.0352 24.7933 49.4872C23.8678 48.9379 23.5569 47.7471 24.0945 46.8157L34.2988 29.2083L38.1412 31.4193H38.1423Z",
    fill: "#41DCEC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7904 33.6526L30.8078 50.8674C30.2305 51.7707 29.0339 52.0442 28.1224 51.4797C27.2073 50.9141 26.9175 49.7175 27.4714 48.7966L37.9878 31.3738L41.7904 33.6526Z",
    fill: "#E8F2FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4135 35.5224L34.4309 52.7373C33.8536 53.6406 32.6569 53.914 31.7454 53.3496C30.8304 52.784 30.5406 51.5873 31.0945 50.6665L41.6108 33.2437L45.4135 35.5224Z",
    fill: "#41DCEC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6859 37.3933L37.7033 54.6081C37.126 55.5114 35.9294 55.7849 35.0179 55.2205C34.1028 54.6549 33.813 53.4582 34.3669 52.5373L44.8833 35.1145L48.6859 37.3933Z",
    fill: "#E8F2FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9574 39.2629L40.9748 56.4777C40.3975 57.3811 39.2009 57.6545 38.2893 57.0901C37.3743 56.5245 37.0845 55.3278 37.6384 54.407L48.1548 36.9841L51.9574 39.2629Z",
    fill: "#41DCEC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9311 41.4846L44.9484 58.6994C44.3712 59.6027 43.1745 59.8762 42.263 59.3118C41.348 58.7462 41.0581 57.5495 41.6121 56.6286L52.1284 39.2058L55.9311 41.4846Z",
    fill: "#E8F2FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59766 21.8882V28.7012L11.498 32.0983V25.2947L5.59766 21.8882Z",
    fill: "url(#paint6_linear_438_1236)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0117 27.03V33.843L19.912 37.2402V30.4365L14.0117 27.03Z",
    fill: "url(#paint7_linear_438_1236)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59766 32.5225V39.3355L11.498 42.7326V35.929L5.59766 32.5225Z",
    fill: "url(#paint8_linear_438_1236)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0117 37.6646V44.4776L19.912 47.8747V41.0711L14.0117 37.6646Z",
    fill: "url(#paint9_linear_438_1236)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59766 43.1567V49.9697L11.498 53.3669V46.5632L5.59766 43.1567Z",
    fill: "url(#paint10_linear_438_1236)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0117 48.2988V55.1118L19.912 58.509V51.7053L14.0117 48.2988Z",
    fill: "url(#paint11_linear_438_1236)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8662 56.5959V63.4089L32.7665 66.8061V60.0025L26.8662 56.5959Z",
    fill: "url(#paint12_linear_438_1236)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2803 61.7378V68.5508L41.1806 71.9479V65.1443L35.2803 61.7378Z",
    fill: "url(#paint13_linear_438_1236)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_438_1236",
    x1: -2.29515,
    y1: 88.5809,
    x2: 58.5918,
    y2: 66.4848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0633C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#063DD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0757E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0769F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0774FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0878FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_438_1236",
    x1: -10.7642,
    y1: 81.2362,
    x2: 26.4724,
    y2: 20.7267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0871F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_438_1236",
    x1: 33.8979,
    y1: 80.1679,
    x2: 34.0779,
    y2: 15.3626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1925A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0647D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_438_1236",
    x1: 24.1758,
    y1: 64.2795,
    x2: 44.4173,
    y2: 64.2795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0871F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_438_1236",
    x1: 76.5901,
    y1: 76.7566,
    x2: 42.3978,
    y2: 57.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#132BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C34BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0739CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063BCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_438_1236",
    x1: 24.1758,
    y1: 46.7493,
    x2: 64.6343,
    y2: 46.7493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#075FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#075FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#075FEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#075DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#075BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0854DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#0A49D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#0C39C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2CB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_438_1236",
    x1: 6.21819,
    y1: 29.3229,
    x2: 10.8716,
    y2: 24.6695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1925A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#142CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0E38C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0940CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0645D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0647D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_438_1236",
    x1: 14.6323,
    y1: 34.4647,
    x2: 19.2857,
    y2: 29.8113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1925A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#142CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0E38C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0940CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0645D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0647D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_438_1236",
    x1: -74.1612,
    y1: 39.9572,
    x2: -74.0443,
    y2: 35.3038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1925A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#142CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0E38C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0940CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0645D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0647D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_438_1236",
    x1: 14.6323,
    y1: 45.0993,
    x2: 19.2857,
    y2: 40.4458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1925A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#142CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0E38C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0940CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0645D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0647D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_438_1236",
    x1: 6.21819,
    y1: 50.5914,
    x2: 10.8716,
    y2: 45.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1925A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#142CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0E38C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0940CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0645D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0647D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_438_1236",
    x1: 14.6323,
    y1: 55.7335,
    x2: 19.2857,
    y2: 51.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1925A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#142CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0E38C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0940CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0645D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0647D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_438_1236",
    x1: 27.4867,
    y1: 64.0307,
    x2: 32.1402,
    y2: 59.3772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1925A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#142CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0E38C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0940CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0645D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0647D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_438_1236",
    x1: 35.9008,
    y1: 69.1725,
    x2: 40.5542,
    y2: 64.5191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1925A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#142CAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0E38C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0940CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0645D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0647D8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsBuilding);
export default __webpack_public_path__ + "static/media/tips-building.c858c0438bd48c32b885f588d376ee5e.svg";
export { ForwardRef as ReactComponent };